import React from 'react';
import doc from "../../images/doctor-image.png"
import {Slide} from "react-reveal";
const ListYourExperiance = () => {
  return (
    <section className="list_your_experiance pt-4">
      <div className="container-fluid">
        <div className="row">
          <Slide left>
          <div className="col-lg-5 pl-4 pr-4 col-md-6 hide_on_med">
            <img width="100%" src={doc} alt=""/>
          </div>
          </Slide>
          <Slide right>
          <div className={`col-lg-7 ${window.innerWidth > 768 ? "" : "text-center"} col-md-6 pt-5 pb-4 d-flex align-items-center text-white`}>
            <div className="inner">
            <h1 className="font-weight-bold" style={{fontSize: `3rem`}}>Are you a five-star Doctor?</h1>
            <h5>List your practice to reach million of patients</h5>
            <ul className="list-unstyled">
            <li>- Attract and engage new patients</li>
            <li>- Build and strengthen your online reputation</li>
            <li>- Deliver a premium experiance patients love</li>
            </ul>
            <button className="btn btn-outline-light">List Your Practice on Docterio</button>
            </div>
          </div>
          </Slide>
          <Slide left>
          <div className="col-lg-6 hide_on_large col-md-6 pt-4">
            <img width="100%" src={doc} alt=""/>
          </div>
          </Slide>
        </div>
      </div>
    </section>
  );
};

export default ListYourExperiance;